import dashboards from './dashboards.reducer';
import reports from './reports.reducer';

const analyticsReducers = {
  dashboards,
  reports,
};

export default analyticsReducers;
